var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"btn-settings",class:{ 'dark-btn': _vm.dark }},'div',_vm.$attrs,false),_vm.$listeners),[_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }